module.exports = __webpack_public_path__ + "img/pingjia.a99aed7e.png";